/** @format */

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled0Percent,
	homefieldIconStarFilled100Percent,
	homefieldIconStarFilled25Percent,
	homefieldIconStarFilled50Percent,
	homefieldIconStarFilled75Percent
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewStarsComponent } from './review-stars.component';

@NgModule({
	imports: [CommonModule, HomefieldIconLibraryModule],
	declarations: [ReviewStarsComponent],
	exports: [ReviewStarsComponent]
})
export class ReviewStarsComponentModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled0Percent,
			homefieldIconStarFilled100Percent,
			homefieldIconStarFilled25Percent,
			homefieldIconStarFilled50Percent,
			homefieldIconStarFilled75Percent
		]);
	}
}
